<template>
  <!-- 单选通讯录选人：家校=学生 / 内部=教职工。创建于 2026-09-21 -->
  <el-dialog
    :title="dialogTitle"
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    append-to-body
    destroy-on-close
    width="1100px"
    top="6vh"
    custom-class="person-scope-dialog"
    @close="onDialogClose"
  >
    <div class="ps-layout" v-loading="treeLoading">
      <div class="ps-left">
        <div class="ps-left-header">
          <i class="el-icon-office-building"></i>
          <span>{{ leftHeaderText }}</span>
        </div>
        <div v-if="showScopeTabs" class="ps-scope-bar">
          <button
            type="button"
            class="ps-scope-btn"
            :class="{ 'is-active': activeDirectoryScope === 'teaching' }"
            @click="setDirectoryScope('teaching')"
          >
            <i class="el-icon-reading"></i> 家校通讯录
          </button>
          <button
            type="button"
            class="ps-scope-btn"
            :class="{ 'is-active': activeDirectoryScope === 'internal' }"
            @click="setDirectoryScope('internal')"
          >
            <i class="el-icon-office-building"></i> 内部通讯录
          </button>
        </div>
        <div v-else class="ps-scope-fixed">
          <i :class="activeDirectoryScope === 'internal' ? 'el-icon-office-building' : 'el-icon-reading'"></i>
          {{ activeDirectoryScope === 'internal' ? '内部通讯录' : '家校通讯录' }}
        </div>
        <div class="ps-left-search">
          <el-input
            v-model="deptFilter"
            clearable
            size="small"
            prefix-icon="el-icon-search"
            placeholder="输入关键字搜索机构/学校..."
          />
        </div>
        <div class="ps-left-tree">
          <el-tree
            ref="deptTree"
            :data="treeData"
            node-key="value"
            highlight-current
            :expand-on-click-node="false"
            :props="treeProps"
            :filter-node-method="filterDeptNode"
            :default-expanded-keys="expandedKeys"
            @node-click="onDeptClick"
          >
            <span class="ps-tree-node" slot-scope="{ node, data }">
              <span class="ps-tree-node__dot" :class="'tone-' + nodeTone(data)"></span>
              <span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
            </span>
          </el-tree>
          <div v-if="!treeLoading && !treeData.length" class="ps-empty">暂无部门</div>
        </div>
      </div>

      <div class="ps-right">
        <div class="ps-meta">
          已选人员：
          <strong v-if="multiple">{{ pendingList.length }} 人</strong>
          <strong v-else-if="pending">{{ pending.label }}</strong>
          <strong v-else>未选择</strong>
          <span class="ps-meta-sep">·</span>
          {{ activeDirectoryScope === 'internal' ? '教职工' : '学生' }}{{ multiple ? '多选' : '单选' }}
        </div>

        <div class="ps-filter-bar">
          <el-input
            v-model="nameFilter"
            clearable
            size="small"
            prefix-icon="el-icon-search"
            placeholder="姓名"
            class="ps-name-input"
            @keyup.enter.native="loadPeople"
          />
          <el-select
            v-if="activeDirectoryScope === 'teaching'"
            v-model="liveTypeFilter"
            clearable
            filterable
            size="small"
            placeholder="人员类型"
            class="ps-type-select"
            :disabled="!liveTypeOptions.length && !liveTypeLoading"
            :loading="liveTypeLoading"
            @change="onLiveTypeFilterChange"
          >
            <el-option label="全部类型" value="" />
            <el-option
              v-for="t in liveTypeOptions"
              :key="t.LiveTypeId"
              :label="t.LiveTypeName || t.LiveTypeId"
              :value="t.LiveTypeId"
            />
          </el-select>
          <el-select
            v-if="showStudentTags && activeDirectoryScope === 'teaching' && studentTagOptions.length"
            v-model="studentTagFilterId"
            clearable
            filterable
            size="small"
            placeholder="学生标签"
            class="ps-tag-select"
            @change="onStudentTagFilterChange"
          >
            <el-option
              v-for="tag in studentTagOptions"
              :key="'tag-' + tag.id"
              :label="formatStudentTagOptionLabel(tag)"
              :value="tag.id"
            />
          </el-select>
          <el-button type="primary" size="small" :disabled="!activeDeptId" @click="loadPeople">查询</el-button>
          <template v-if="multiple">
            <el-button size="small" :disabled="!activeDeptId || !tableRows.length" @click="selectAllCurrentDept">全选当前部门</el-button>
            <el-button size="small" :disabled="!activeDeptId || !tableRows.length" @click="clearCurrentDept">清空当前部门</el-button>
            <el-button size="small" type="text" :disabled="!pendingList.length" @click="clearPending">清空全部</el-button>
          </template>
          <el-button v-else size="small" type="text" :disabled="!pending" @click="clearPending">清空已选</el-button>
        </div>

        <div class="ps-hint" v-if="activeDeptId">
          当前部门：<strong>{{ activeDeptName }}</strong>
          <span class="ps-hint-sub">
            （{{ activeDirectoryScope === 'teaching' ? '家校' : '内部' }} · {{ tableRows.length }} 人）
          </span>
        </div>
        <div class="ps-hint ps-hint--warn" v-else>请先在左侧选择部门</div>

        <div class="ps-table-wrap" ref="tableWrap" v-loading="tableLoading">
          <el-table
            ref="peopleTable"
            :data="pagedRows"
            size="small"
            stripe
            highlight-current-row
            :height="tableHeight"
            @row-click="onRowClick"
            @current-change="onCurrentChange"
          >
            <el-table-column width="46" align="center" class-name="ps-radio-col">
              <template slot-scope="scope">
                <el-checkbox
                  v-if="multiple"
                  class="ps-row-check"
                  :value="isPending(scope.row)"
                  @change="toggleRow(scope.row)"
                  @click.native.stop
                />
                <el-radio
                  v-else
                  class="ps-row-radio"
                  :value="pendingValue"
                  :label="String(scope.row.value)"
                  @input="selectRow(scope.row)"
                  @click.native.stop
                >&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="label" label="姓名" min-width="110" show-overflow-tooltip />
            <el-table-column label="类型" min-width="100" align="center">
              <template slot-scope="scope">
                <span class="ps-type-tag" :class="'ps-type-tag--' + rowTypeTone(scope.row)">
                  {{ rowTypeLabel(scope.row) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showStudentTags && activeDirectoryScope === 'teaching'"
              label="学生标签"
              min-width="140"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.studentTags && scope.row.studentTags.length">
                  {{ (scope.row.studentTags || []).map((t) => t.tagName).join('、') }}
                </span>
                <span v-else class="ps-avatar-empty">未设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="deptLabel" label="部门" min-width="140" show-overflow-tooltip />
            <el-table-column label="头像" width="72" align="center" header-align="center">
              <template slot-scope="scope">
                <oss-media-thumbs
                  v-if="scope.row.HeadPhotoImage"
                  :media="scope.row.HeadPhotoImage"
                  thumb-width="40px"
                  thumb-height="40px"
                />
                <span v-else class="ps-avatar-empty">无</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="ps-pager-wrap">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :page-size="pageSize"
            :total="tableRows.length"
            :current-page="page"
            @current-change="handlePageChange"
          />
        </div>

        <div class="ps-actions">
          <el-button @click="innerVisible = false">取消</el-button>
          <el-button type="primary" :disabled="multiple ? !pendingList.length : !pending" @click="confirm">
            <template v-if="multiple">确定{{ pendingList.length ? `（${pendingList.length}人）` : '' }}</template>
            <template v-else>确定{{ pending ? `（${pending.label}）` : '' }}</template>
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getTeachingDepartmentTree, getInternalDepartmentTree } from '../api/modules/department'
import { normalizeDeptId } from '../utils/deptCascaderProps'
import { getStudentSelectList, getTeacherMasterListPage } from '../api/modules/personnel'
import { fetchStudentLiveTypesByDeptId } from '../utils/studentLiveType'
import {
  resolveCampusIdFromTreeNode,
  fetchAndMapStudentTags,
  formatStudentTagOptionLabel,
} from '../utils/studentScopeTags'

export default {
  name: 'PersonScopePickerDialog',
  props: {
    visible: { type: Boolean, default: false },
    /** teaching=家校学生；internal=内部教职工 */
    directoryScope: { type: String, default: 'teaching' },
    /** 是否显示家校/内部切换（单业务场景建议 false） */
    showScopeTabs: { type: Boolean, default: false },
    scopeDepartmentId: { type: [Number, String], default: 0 },
    title: { type: String, default: '' },
    /** 已选人员 Id（学生 Id / TeacherMaster Id） */
    value: { type: [Number, String], default: null },
    /** 已选人员姓名（回显） */
    label: { type: String, default: '' },
    /** 多选。确认时回传人员数组；默认仍为单选。最后修改：2026-09-25 */
    multiple: { type: Boolean, default: false },
    /** 多选回显：[{ id, name }] */
    selectedPeople: { type: Array, default: () => [] },
    /** 确定后是否自动关闭；为 false 时由业务页在二次确认通过后自行关闭。最后修改：2026-10-04 */
    closeOnConfirm: { type: Boolean, default: true },
    /**
     * 家校选学生时按人员类型过滤（GetStudentSelectList.liveTypeId，逗号分隔多类型）。
     * 空表示不限制。创建于 2026-10-20
     */
    liveTypeId: { type: String, default: '' },
    /**
     * 家校选学生时是否展示学生标签筛选/列。默认开（选学生公共能力）。最后更新：2026-10-29
     */
    showStudentTags: { type: Boolean, default: true },
  },
  data() {
    return {
      directoryScopeLocal: 'teaching',
      treeLoading: false,
      tableLoading: false,
      deptFilter: '',
      nameFilter: '',
      /** 弹窗内人员类型筛选（学生）；空=全部。创建于 2026-10-20 */
      liveTypeFilter: '',
      liveTypeOptions: [],
      liveTypeLoading: false,
      /** 学生标签筛选；空=全部。最后更新：2026-10-29 */
      studentTagFilterId: null,
      studentTagOptions: [],
      teachingTree: [],
      internalTree: [],
      teachingExpandedKeys: [],
      internalExpandedKeys: [],
      treeProps: { label: 'label', children: 'children' },
      activeDeptId: '',
      activeDeptName: '',
      activeDeptOrgType: '',
      activeCampusId: '',
      rawPeopleRows: [],
      tableRows: [],
      page: 1,
      pageSize: 10,
      tableHeight: 400,
      pending: null,
      pendingList: [],
      _resizeBound: false,
      _onResize: null,
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
    /** 当前生效通讯录：有切换条用本地态，否则用入参。创建于 2026-09-21 */
    activeDirectoryScope() {
      if (this.showScopeTabs) return this.directoryScopeLocal
      return this.directoryScope === 'internal' ? 'internal' : 'teaching'
    },
    dialogTitle() {
      if (this.title) return this.title
      return this.activeDirectoryScope === 'internal' ? '选择教职工' : '选择学生'
    },
    leftHeaderText() {
      return this.activeDirectoryScope === 'internal' ? '选择内部机构' : '选择机构 / 学校'
    },
    treeData() {
      return this.activeDirectoryScope === 'internal' ? this.internalTree : this.teachingTree
    },
    expandedKeys() {
      return this.activeDirectoryScope === 'internal' ? this.internalExpandedKeys : this.teachingExpandedKeys
    },
    pagedRows() {
      const rows = this.tableRows || []
      const size = this.pageSize || 10
      const page = this.page || 1
      const start = (page - 1) * size
      return rows.slice(start, start + size)
    },
    pendingValue() {
      return this.pending ? String(this.pending.value) : ''
    },
    /** 父级传入的允许类型（逗号分隔）；空表示不限制 */
    parentLiveTypeIds() {
      const raw = (this.liveTypeId || '').trim()
      if (!raw) return []
      return raw.split(',').map((x) => String(x || '').trim()).filter(Boolean)
    },
    /**
     * 查询用类型：弹窗内选中优先；未选则回退父级约束（多值逗号）。
     * 创建于 2026-10-20
     */
    effectiveLiveTypeId() {
      const picked = (this.liveTypeFilter || '').trim()
      if (picked) return picked
      return (this.liveTypeId || '').trim()
    },
  },
  watch: {
    visible(val) {
      if (val) this.openInit()
    },
    deptFilter(val) {
      const tree = this.$refs.deptTree
      if (tree) tree.filter(val)
    },
    directoryScope: {
      immediate: true,
      handler(val) {
        if (val === 'teaching' || val === 'internal') {
          this.directoryScopeLocal = val
        }
      },
    },
    /** 外部切换人员类型后，刷新选项并重拉名单 */
    liveTypeId() {
      if (!this.visible || this.activeDirectoryScope !== 'teaching') return
      this.loadLiveTypeOptions().then(() => {
        if (this.activeDeptId) this.loadPeople()
      })
    },
    scopeDepartmentId() {
      if (!this.visible || this.activeDirectoryScope !== 'teaching') return
      this.loadLiveTypeOptions()
    },
  },
  beforeDestroy() {
    this.unbindResize()
  },
  methods: {
    openInit() {
      this.directoryScopeLocal = this.directoryScope === 'internal' ? 'internal' : 'teaching'
      this.deptFilter = ''
      this.nameFilter = ''
      this.liveTypeFilter = ''
      this.studentTagFilterId = null
      this.studentTagOptions = []
      this.activeDeptId = ''
      this.activeDeptName = ''
      this.activeDeptOrgType = ''
      this.activeCampusId = ''
      this.rawPeopleRows = []
      this.tableRows = []
      this.page = 1
      this.pending = null
      this.pendingList = []
      if (this.multiple) {
        const seed = Array.isArray(this.selectedPeople) ? this.selectedPeople : []
        this.pendingList = seed
          .map((item) => this.toPending({
            value: item && (item.id != null ? item.id : item.value),
            label: (item && (item.name || item.label)) || '',
            personType: this.activeDirectoryScope === 'internal' ? 'teacher' : 'student',
            deptId: item && item.deptId,
            deptLabel: item && item.deptLabel,
          }))
          .filter((item) => item && normalizeDeptId(item.value))
      } else if (this.value != null && this.value !== '' && normalizeDeptId(this.value)) {
        this.pending = {
          value: String(this.value),
          label: this.label || String(this.value),
          personType: this.activeDirectoryScope === 'internal' ? 'teacher' : 'student',
          deptId: '',
          deptLabel: '',
        }
      }
      this.loadTrees()
      if (this.activeDirectoryScope === 'teaching') this.loadLiveTypeOptions()
      else {
        this.liveTypeOptions = []
        this.liveTypeLoading = false
      }
      this.$nextTick(() => this.syncTableHeight())
    },
    onDialogClose() {
      this.unbindResize()
      this.deptFilter = ''
      this.nameFilter = ''
      this.liveTypeFilter = ''
      this.liveTypeOptions = []
      this.studentTagFilterId = null
      this.studentTagOptions = []
      this.activeDeptId = ''
      this.activeDeptName = ''
      this.activeDeptOrgType = ''
      this.activeCampusId = ''
      this.rawPeopleRows = []
      this.tableRows = []
      this.page = 1
      this.tableLoading = false
    },
    setDirectoryScope(scope) {
      if (!this.showScopeTabs) return
      if (scope !== 'teaching' && scope !== 'internal') return
      if (this.directoryScopeLocal === scope) return
      this.directoryScopeLocal = scope
      this.$emit('update:directoryScope', scope)
      this.deptFilter = ''
      this.liveTypeFilter = ''
      this.studentTagFilterId = null
      this.studentTagOptions = []
      this.activeDeptId = ''
      this.activeDeptName = ''
      this.activeDeptOrgType = ''
      this.activeCampusId = ''
      this.rawPeopleRows = []
      this.tableRows = []
      this.pending = null
      this.pendingList = []
      if (scope === 'teaching') this.loadLiveTypeOptions()
      else this.liveTypeOptions = []
      this.$nextTick(() => this.autoSelectDefaultDept())
    },
    /** 加载本校人员类型；若父级传入 liveTypeId 则只保留允许项。创建于 2026-10-20 */
    loadLiveTypeOptions() {
      const scopeId = normalizeDeptId(this.scopeDepartmentId)
      if (!scopeId) {
        this.liveTypeOptions = []
        return Promise.resolve()
      }
      this.liveTypeLoading = true
      return fetchStudentLiveTypesByDeptId(scopeId)
        .then((list) => {
          const allowed = this.parentLiveTypeIds
          let opts = list || []
          if (allowed.length) {
            const set = new Set(allowed.map(String))
            opts = opts.filter((t) => set.has(String(t.LiveTypeId)))
          }
          this.liveTypeOptions = opts
          if (this.liveTypeFilter && !opts.some((t) => String(t.LiveTypeId) === String(this.liveTypeFilter))) {
            this.liveTypeFilter = ''
          }
        })
        .catch(() => {
          this.liveTypeOptions = []
        })
        .finally(() => {
          this.liveTypeLoading = false
        })
    },
    onLiveTypeFilterChange() {
      if (this.activeDeptId) this.loadPeople()
    },
    onStudentTagFilterChange() {
      this.applyClientFilters()
    },
    formatStudentTagOptionLabel,
    /** 表格「类型」列文案：学生显示寄宿/人员类型名，教职工固定文案 */
    rowTypeLabel(row) {
      if (!row) return '—'
      if (row.personType === 'teacher') return '教职工'
      return (row.liveTypeName || '').trim() || '学生'
    },
    /**
     * 类型标签色调：按 LiveTypeId / 名称区分住校、走读、半通等。创建于 2026-10-20
     * @returns {'teacher'|'school'|'home'|'homeSpe'|'default'}
     */
    rowTypeTone(row) {
      if (!row) return 'default'
      if (row.personType === 'teacher') return 'teacher'
      const id = String(row.liveTypeId || '').trim().toLowerCase()
      const name = String(row.liveTypeName || '').trim()
      if (id === 'live_school' || /住校/.test(name)) return 'school'
      if (id === 'live_home_spe' || /半通|特殊走读|特走/.test(name)) return 'homeSpe'
      if (id === 'live_home' || id.indexOf('live_home') === 0 || /走读|通校/.test(name)) return 'home'
      if (!id && !name) return 'default'
      // 自定义类型：按 id 散列到固定色板，保证同类型同色
      let hash = 0
      const key = id || name
      for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0
      const tones = ['toneA', 'toneB', 'toneC', 'toneD']
      return tones[hash % tones.length]
    },
    normalizeTreeRoot(root) {
      if (!root) return []
      if (Number(root.value || 0) === 0 && root.children && root.children.length) {
        return root.children
      }
      return [root]
    },
    firstTreeKey(nodes) {
      if (!nodes || !nodes.length) return ''
      return nodes[0] && nodes[0].value != null ? String(nodes[0].value) : ''
    },
    loadTrees() {
      this.treeLoading = true
      const scopeId = normalizeDeptId(this.scopeDepartmentId)
      const needTeaching = this.showScopeTabs || this.activeDirectoryScope === 'teaching'
      const needInternal = this.showScopeTabs || this.activeDirectoryScope === 'internal'
      const tasks = []
      if (needTeaching) {
        tasks.push(
          getTeachingDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
            .then((res) => {
              this.teachingTree = this.normalizeTreeRoot(res && res.data && res.data.response)
              const key = this.firstTreeKey(this.teachingTree)
              this.teachingExpandedKeys = key ? [key] : []
            })
            .catch(() => {
              this.teachingTree = []
            })
        )
      }
      if (needInternal) {
        tasks.push(
          getInternalDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
            .then((res) => {
              this.internalTree = this.normalizeTreeRoot(res && res.data && res.data.response)
              const key = this.firstTreeKey(this.internalTree)
              this.internalExpandedKeys = key ? [key] : []
            })
            .catch(() => {
              this.internalTree = []
            })
        )
      }
      Promise.all(tasks).finally(() => {
        this.treeLoading = false
        this.$nextTick(() => {
          this.syncTableHeight()
          this.autoSelectDefaultDept()
        })
      })
    },
    filterDeptNode(value, data) {
      if (!value) return true
      return (data.label || '').indexOf(value) !== -1
    },
    nodeTone(data) {
      if (!data) return 'default'
      const type = (data.DeptOrgType || data.deptOrgType || '').toLowerCase()
      if (type === 'school' || data.IsCompany || data.isCompany) return 'school'
      if (type === 'campus') return 'campus'
      if (type === 'period' || type === 'stage') return 'period'
      if (type === 'grade') return 'grade'
      if (type === 'class') return 'class'
      if (data.BigType === 0 || data.bigType === 0) return 'internal'
      return 'default'
    },
    /**
     * 打开弹窗后默认选中左侧第一个节点并拉名单（不展开子级）。最后更新：2026-10-29
     */
    autoSelectDefaultDept() {
      if (!this.visible || this.activeDeptId) return
      const treeData = this.treeData || []
      const data = treeData[0]
      if (!data) return
      const key = data.value != null ? data.value : data.Id
      if (key == null || key === '') return

      this.$nextTick(() => {
        if (!this.visible || this.activeDeptId) return
        const tree = this.$refs.deptTree
        if (!tree) return
        tree.setCurrentKey(key)
        const node = tree.getNode(key)
        this.onDeptClick(node && node.data ? node.data : data, node || null)
      })
    },
    onDeptClick(data, node) {
      const id = data && (data.value != null ? data.value : data.Id)
      if (id == null || !normalizeDeptId(id)) {
        this.$message.warning('请选择具体部门')
        return
      }
      this.activeDeptId = String(id)
      this.activeDeptName = data.label || data.Name || ''
      const deptType = String((data.DeptOrgType != null ? data.DeptOrgType : data.deptOrgType) || '').toLowerCase()
      this.activeDeptOrgType = deptType || 'class'
      this.activeCampusId = resolveCampusIdFromTreeNode(node) || (deptType === 'campus' ? String(id) : '')
      this.nameFilter = ''
      this.studentTagFilterId = null
      this.page = 1
      this.loadPeople()
    },
    loadPeople() {
      const deptId = this.activeDeptId
      if (!deptId) return
      this.tableLoading = true
      this.page = 1
      const name = (this.nameFilter || '').trim()
      const isTeaching = this.activeDirectoryScope === 'teaching'
      const request = isTeaching
        ? (() => {
            const params = { departmentId: deptId, name }
            const lt = this.effectiveLiveTypeId
            if (lt) params.liveTypeId = lt
            return getStudentSelectList(params).then((res) => {
              const list = (res.data && res.data.response) || []
              return list.map((s) => ({
                value: String(s.Id),
                label: s.Name || s.StuName || '',
                deptId: String(s.DepartmentId || deptId),
                deptLabel: s.DepartmentName || this.activeDeptName,
                personType: 'student',
                liveTypeId: s.LiveTypeId || s.liveTypeId || '',
                liveTypeName: s.LiveType || s.liveType || s.LiveTypeName || s.liveTypeName || '',
                studentTags: [],
                HeadPhotoImage: s.HeadPhotoImage || '',
              }))
            })
          })()
        : this.loadAllTeachers(deptId, name)
      request
        .then((rows) => {
          const list = rows || []
          if (isTeaching && this.showStudentTags) {
            return fetchAndMapStudentTags({
              deptId: this.activeDeptId,
              campusId: this.activeCampusId,
              deptOrgType: this.activeDeptOrgType,
              rows: list,
              rowIdKey: 'value',
            }).then(({ tagOptions, rows: mapped }) => {
              this.studentTagOptions = tagOptions
              this.rawPeopleRows = mapped
              this.applyClientFilters()
            })
          }
          this.studentTagOptions = []
          this.rawPeopleRows = list
          this.applyClientFilters()
        })
        .catch(() => {
          this.rawPeopleRows = []
          this.tableRows = []
          this.studentTagOptions = []
        })
        .finally(() => {
          this.tableLoading = false
          this.$nextTick(() => {
            this.syncTableHeight()
            this.syncCurrentRow()
            this.prefetchAvatars()
          })
        })
    },
    /** 按学生标签做客户端筛选。最后更新：2026-10-29 */
    applyClientFilters() {
      let rows = this.rawPeopleRows || []
      if (this.studentTagFilterId) {
        const tid = String(this.studentTagFilterId)
        rows = rows.filter((r) => (r.studentTags || []).some((t) => String(t.id) === tid))
      }
      this.tableRows = rows
      this.page = 1
      this.$nextTick(() => {
        this.syncCurrentRow()
        this.prefetchAvatars()
      })
    },
    async loadAllTeachers(deptId, name) {
      const pageSize = 500
      let page = 1
      let total = 0
      const all = []
      do {
        const res = await getTeacherMasterListPage({
          page,
          departmentId: deptId,
          intPageSize: pageSize,
          teacherName: name,
        })
        const pageData = (res.data && res.data.response) || {}
        const list = pageData.data || []
        total = pageData.dataCount || list.length
        list.forEach((t) => {
          all.push({
            value: String(t.Id),
            label: t.TeacherName || t.Name || '',
            deptId: String(t.DepartmentId || deptId),
            deptLabel:
              t.DepartmentName ||
              t.ContextDepartmentName ||
              t.DefaultDepartmentName ||
              this.activeDeptName,
            personType: 'teacher',
            HeadPhotoImage: t.HeadPhotoImage || '',
          })
        })
        if (!list.length || all.length >= total) break
        page += 1
      } while (page <= 200)
      return all
    },
    handlePageChange(page) {
      this.page = page
      this.$nextTick(() => {
        this.syncCurrentRow()
        this.prefetchAvatars()
      })
    },
    prefetchAvatars() {
      const rows = this.pagedRows || []
      if (!rows.length || !this.prefetchListOssMedia) return
      this.prefetchListOssMedia(rows, 'HeadPhotoImage')
    },
    syncTableHeight() {
      const measure = () => {
        const wrap = this.$refs.tableWrap
        if (!wrap) return
        const h = Math.floor(wrap.clientHeight)
        if (h > 120 && h !== this.tableHeight) {
          this.tableHeight = h
          this.$nextTick(() => {
            if (this.$refs.peopleTable && this.$refs.peopleTable.doLayout) {
              this.$refs.peopleTable.doLayout()
            }
          })
        }
      }
      this.$nextTick(() => {
        measure()
        setTimeout(measure, 60)
      })
      this.bindResize()
    },
    bindResize() {
      if (this._resizeBound) return
      this._onResize = () => this.syncTableHeight()
      window.addEventListener('resize', this._onResize)
      this._resizeBound = true
    },
    unbindResize() {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize)
        this._onResize = null
      }
      this._resizeBound = false
    },
    syncCurrentRow() {
      const table = this.$refs.peopleTable
      if (!table) return
      const hit = (this.pagedRows || []).find((r) => this.pending && String(r.value) === String(this.pending.value))
      if (hit) table.setCurrentRow(hit)
      else table.setCurrentRow()
    },
    onRowClick(row) {
      if (this.multiple) {
        this.toggleRow(row)
        return
      }
      this.selectRow(row)
    },
    onCurrentChange(row) {
      if (this.multiple || !row) return
      this.selectRow(row)
    },
    toPending(row) {
      if (!row || row.value == null || row.value === '') return null
      return {
        value: String(row.value),
        label: row.label || String(row.value),
        deptId: row.deptId || '',
        deptLabel: row.deptLabel || '',
        personType: row.personType || (this.activeDirectoryScope === 'internal' ? 'teacher' : 'student'),
        HeadPhotoImage: row.HeadPhotoImage || '',
      }
    },
    isPending(row) {
      if (!row) return false
      const id = String(row.value)
      return (this.pendingList || []).some((item) => String(item.value) === id)
    },
    toggleRow(row) {
      const next = this.toPending(row)
      if (!next) return
      const index = (this.pendingList || []).findIndex((item) => String(item.value) === next.value)
      if (index >= 0) {
        this.pendingList.splice(index, 1)
        return
      }
      this.pendingList.push(next)
    },
    selectAllCurrentDept() {
      const map = {}
      ;(this.pendingList || []).forEach((item) => {
        map[String(item.value)] = item
      })
      ;(this.tableRows || []).forEach((row) => {
        const next = this.toPending(row)
        if (next) map[next.value] = next
      })
      this.pendingList = Object.keys(map).map((key) => map[key])
    },
    clearCurrentDept() {
      const ids = new Set((this.tableRows || []).map((row) => String(row.value)))
      this.pendingList = (this.pendingList || []).filter((item) => !ids.has(String(item.value)))
    },
    selectRow(row) {
      if (!row) return
      this.pending = {
        value: String(row.value),
        label: row.label,
        deptId: row.deptId,
        deptLabel: row.deptLabel,
        personType: row.personType,
        HeadPhotoImage: row.HeadPhotoImage || '',
      }
    },
    clearPending() {
      if (this.multiple) {
        this.pendingList = []
        return
      }
      this.pending = null
      const table = this.$refs.peopleTable
      if (table) table.setCurrentRow()
    },
    confirm() {
      if (this.multiple) {
        if (!this.pendingList.length) {
          this.$message.warning('请先选择人员')
          return
        }
        this.$emit('confirm', this.pendingList.map((item) => ({
          id: normalizeDeptId(item.value) || String(item.value),
          name: item.label,
          personType: item.personType,
          deptId: item.deptId,
          deptLabel: item.deptLabel,
        })))
        if (this.closeOnConfirm) this.innerVisible = false
        return
      }
      if (!this.pending) {
        this.$message.warning('请先选择人员')
        return
      }
      this.$emit('confirm', {
        id: normalizeDeptId(this.pending.value) || String(this.pending.value),
        name: this.pending.label,
        personType: this.pending.personType,
        deptId: this.pending.deptId,
        deptLabel: this.pending.deptLabel,
      })
      if (this.closeOnConfirm) this.innerVisible = false
    },
  },
}
</script>

<style scoped>
.ps-layout {
  display: flex;
  gap: 0;
  height: 640px;
  max-height: calc(90vh - 140px);
  min-height: 420px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.ps-left {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e2e8f0;
  background: #fff;
  min-height: 0;
  overflow: hidden;
}
.ps-left-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 14px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  flex-shrink: 0;
}
.ps-left-header i {
  color: var(--btn-primary, #2563eb);
}
.ps-scope-bar {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 0 12px 10px;
  flex-shrink: 0;
}
.ps-scope-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
}
.ps-scope-btn.is-active {
  background: #eff6ff;
  border-color: #2563eb;
  color: #1d4ed8;
}
.ps-scope-fixed {
  margin: 0 12px 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ps-left-search {
  padding: 0 12px 10px;
  flex-shrink: 0;
}
.ps-left-tree {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 8px 12px;
}
.ps-left-tree >>> .el-tree-node__content {
  height: 34px;
  border-radius: 6px;
}
.ps-left-tree >>> .el-tree-node.is-current > .el-tree-node__content {
  background: #dbeafe;
}
.ps-tree-node {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.ps-tree-node__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #94a3b8;
  flex-shrink: 0;
}
.ps-tree-node__dot.tone-school {
  background: var(--btn-primary, #2563eb);
}
.ps-tree-node__dot.tone-campus {
  background: #f59e0b;
}
.ps-tree-node__dot.tone-period {
  background: #8b5cf6;
}
.ps-tree-node__dot.tone-grade {
  background: #06b6d4;
}
.ps-tree-node__dot.tone-class {
  background: #64748b;
}
.ps-tree-node__dot.tone-internal {
  background: #0ea5e9;
}
.ps-tree-node__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ps-empty {
  text-align: center;
  color: #94a3b8;
  padding: 24px 8px;
  font-size: 13px;
}
.ps-right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 14px 10px;
  min-height: 0;
}
.ps-meta {
  font-size: 13px;
  color: #475569;
  margin-bottom: 10px;
  flex-shrink: 0;
}
.ps-meta-sep {
  margin: 0 6px;
  color: #cbd5e1;
}
.ps-filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.ps-name-input {
  width: 160px;
}
.ps-type-select {
  width: 140px;
}
.ps-tag-select {
  width: 200px;
}
.ps-type-tag {
  display: inline-block;
  max-width: 100%;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 20px;
  border: 1px solid transparent;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.ps-type-tag--teacher {
  color: #b45309;
  background: #fffbeb;
  border-color: #fcd34d;
}
.ps-type-tag--school {
  color: #047857;
  background: #ecfdf5;
  border-color: #6ee7b7;
}
.ps-type-tag--home {
  color: #1d4ed8;
  background: #eff6ff;
  border-color: #93c5fd;
}
.ps-type-tag--homeSpe {
  color: #c2410c;
  background: #fff7ed;
  border-color: #fdba74;
}
.ps-type-tag--default {
  color: #64748b;
  background: #f8fafc;
  border-color: #e2e8f0;
}
.ps-type-tag--toneA {
  color: #6d28d9;
  background: #f5f3ff;
  border-color: #c4b5fd;
}
.ps-type-tag--toneB {
  color: #0e7490;
  background: #ecfeff;
  border-color: #67e8f9;
}
.ps-type-tag--toneC {
  color: #be185d;
  background: #fdf2f8;
  border-color: #f9a8d4;
}
.ps-type-tag--toneD {
  color: #4338ca;
  background: #eef2ff;
  border-color: #a5b4fc;
}
.ps-hint {
  font-size: 13px;
  color: #334155;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.ps-hint-sub {
  color: #64748b;
  margin-left: 4px;
}
.ps-hint--warn {
  color: #b45309;
}
.ps-table-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.ps-table-wrap >>> .el-table__body tr {
  cursor: pointer;
}
/* 单选列只显示圆点：隐藏 label，避免窄列被省略成「..」。最后更新：2026-09-21 */
.ps-table-wrap >>> .ps-row-radio .el-radio__label {
  display: none;
}
.ps-table-wrap >>> .ps-radio-col .cell {
  padding-left: 8px;
  padding-right: 8px;
  overflow: visible;
}
.ps-avatar-empty {
  color: #c0c4cc;
  font-size: 12px;
}
.ps-pager-wrap {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  flex-shrink: 0;
}
.ps-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 10px;
  flex-shrink: 0;
}
</style>
